import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { listSupportLinks } from "../services/api";

const providerLabel = {
  paypal: "PayPal",
  venmo: "Venmo",
};

const providerIcon = {
  paypal: "PP",
  venmo: "V",
};

function SupportPage() {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await listSupportLinks();
        setLinks(response.data || []);
      } catch {
        setLinks([]);
      }
    };
    load();
  }, []);

  return (
    <section>
      <Card className="glass-card text-light mb-4">
        <Card.Body>
          <h1 className="section-title mb-2">Support</h1>
          <p className="text-muted-soft mb-0">
            Donations help keep this important work going by supporting outreach, veteran services, and ongoing community operations.
          </p>
        </Card.Body>
      </Card>

      <Card className="glass-card text-light mb-4">
        <Card.Body>
          <div className="donations-flyer-wrap">
            <img
              src="/donations-items-flyer-v2.svg?v=20260428"
              alt="In-kind donation items flyer for veterans support"
              className="donations-flyer-image"
              loading="lazy"
            />
          </div>
          <div className="mt-3">
            <h2 className="h4 mb-2">Donate Essential Items</h2>
            <p className="text-muted-soft mb-0">
              Community members can also donate everyday essentials in addition to financial support.
              Share this flyer to help more people contribute meaningful items for veterans rebuilding their lives.
            </p>
          </div>
        </Card.Body>
      </Card>

      {links.length > 0 && (
        <Card className="glass-card text-light">
          <Card.Body className="d-flex flex-column gap-3">
            {links.map((item) => {
              const provider = String(item.provider || "").toLowerCase();
              const label = providerLabel[provider] || provider;
              return (
                <Card key={`support-link-${provider}`} className="resource-card text-light">
                  <Card.Body className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                    <div>
                      <div className="fw-semibold">
                        <span className="me-2">{providerIcon[provider] || "*"}</span>
                        {label}
                      </div>
                      {item.description && <div className="small text-muted-soft mt-1">{item.description}</div>}
                    </div>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-outline-warning btn-sm"
                    >
                      Support Here
                    </a>
                  </Card.Body>
                </Card>
              );
            })}
          </Card.Body>
        </Card>
      )}
    </section>
  );
}

export default SupportPage;
